import {
  FILE_EDI_RECORD_REQUEST,
  FILE_EDI_RECORD_SUCCESS,
  FILE_EDI_RECORD_FAILURE,
  CLEAR_FILE_SUCCESS_POPUP,
} from "../actionTypes";

const intialState = {
  loading: false,
  recordFiled: [],
  error: "",
};

const fileRequestReducer = (state = intialState, action) => {
  switch (action.type) {
    case FILE_EDI_RECORD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case CLEAR_FILE_SUCCESS_POPUP:
      return {
        ...state,
        recordFiled: [],
      };
    case FILE_EDI_RECORD_SUCCESS:
      return {
        loading: false,
        recordFiled: action.payload,
        error: "",
      };
    case FILE_EDI_RECORD_FAILURE:
      return {
        loading: false,
        recordFiled: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
export default fileRequestReducer;
